import {DomWindow, DomWindowBounds, DomWindowConfig} from './DomWindow';
import {MessageBarAction, ProgressBar} from './DomMenu';
import {ClickSelectMode, GridCtrl, ObjectTreeCtrl, TreeCtrl} from './GridCtrl';
import { app } from './boot';
import $ from 'jquery';
import { dragdrop1d, EL, keyname} from './util/DomUtils';
import { registerClass } from './Plugin';
import { LocalDb } from './db/Database';
import { MemoItemSearchMatcher } from './util/AppUtils';
import {slot} from "./lib/slot";
import {observable} from "./lib/signal";
import {QRCode} from "../lib/qrcodejs/qrcode";
import {OnNavigateOptions} from "./ui/Activity";
import {MemoActivity} from "./memo/MemoActivity";
import {ActivityHolder} from "./ui/ActivityHolder";

@registerClass(DomWindow.windowTypes)
export class LogWindow extends DomWindow {
    outDiv: HTMLDivElement;
    constructor(id:string, defaultBounds:DomWindowBounds) {
        super(id, defaultBounds);
        this.hideOnClose = true;
        this.addTitleButton("clear",()=>this.outDiv.innerHTML = "");
        this.contentEl.classList.add('logWindow');
        this.outDiv = this.contentEl;
    }
    renderText(text:string) : string {
        return this.context.markdown.render(text, true);
    }
    print(message:string, css : {[key:string]: string} = {}, details?: any, actions?: MessageBarAction[]) {
        let innerHTML = `<time>${new Date().toLocaleTimeString('de')}</time> ${this.renderText(message)}`;
        this.outDiv.appendChild(EL(typeof details === 'string' ? 'details' : 'div',
            { style: css, 'class': css?.className },
            EL(typeof details === 'string' ? 'summary' : 'span', { innerHTML },
                details !== undefined && typeof details !== 'string' ? EL('button', {'class':'actionItem', onclick: () => ObjectTreeCtrl.showDialog(details, message, {expandRoot: true}) }, '>>') : undefined,
                ...(actions || [])?.map(([title, action]) => EL("button", {'class':'actionItem', 'onclick': action}, title))
            ),
            typeof details === 'string' ? EL('div', {}, details) : '',
            ))
        this.contentEl.scrollTop = this.contentEl.scrollHeight;
    }
    error(message:string, details?: string) {
        this.print(message, {backgroundColor:"#bb5500",color:"white",className:'log-error'}, details);
    }
}

@registerClass(DomWindow.windowTypes)
export class UserMgmtWindow extends DomWindow {
    localSettings = ["websocketTarget","websocketAltTarget","enableSound","scriptAllowList","minimapTimeout","minimapPosition","rpcTimeout"];
    userMetaSettingsArray = [];
    userMetaSettingsString = ["allow_users_read","allow_users_readwrite","public"];
    constructor(id:string, defaultBounds:DomWindowBounds) {
        super(id, defaultBounds);
        this.hideOnClose = true;
        this.initUI2();
    }
    initUI2() {
        this.contentEl.replaceChildren();
        const $loginGroup = $("<fieldset><legend>Login</legend></fieldset>").appendTo(this.contentEl);
        $("<input type='text' id='um_username' placeholder='username'><br><input type='password' id='um_password' placeholder='password'><br><input type='checkbox' id='um_savepw'><label for='um_savepw'>store password</label><br>").appendTo($loginGroup);
        $("<button>login</button>").appendTo($loginGroup).click(()=>{
            this.login();
            app.remote.requestUsername=localStorage.loginUser=$("#um_username").val() as string;
            if (($("#um_savepw")[0] as HTMLInputElement).checked) localStorage.loginPassword=$("#um_password").val();
            else localStorage.removeItem("loginPassword");
        });
        $("<button>register</button>").appendTo($loginGroup).click(()=>{
            app.remote.register($("#um_username").val() as string, $("#um_password").val() as string);
        });
        $("<button></button>").text(localStorage.offlineMode ? 'go online' : 'go offline').appendTo($loginGroup).click(function(){
            localStorage.offlineMode = localStorage.offlineMode ? '' : 'YES';
            $(this).text(localStorage.offlineMode ? 'go online' : 'go offline');
            if (localStorage.offlineMode) {
                app.remote.websocketDisconnect();
            } else {
                app.remote.websocketConnect();
            }
        });
        $("<button>logout</button>").appendTo($loginGroup).click(()=>{
            if(!confirm("Are you sure? This clears all locally cached/unsynced data.")) return;
            app.remote.requestUsername=localStorage.loginUser=localStorage.loginPassword="";
            app.db.clearLocalData();
            app.remote.websocketDisconnect();
            location=location;
        });
        $("<button>refresh</button>").appendTo($loginGroup).click(()=>{
            try { caches.delete('mysite-dynamic'); } catch(ex) {}
            location=location;
        });
        if (localStorage.loginUser)$("#um_username").val(localStorage.loginUser)
        app.remote.requestUsername=localStorage.loginUser;
        if (localStorage.loginPassword){
            $("#um_password").val(localStorage.loginPassword);
            ($("#um_savepw")[0] as HTMLInputElement).checked=true;
        }
        const $buildInfoGroup = $("<fieldset><legend>Build Information</legend></fieldset>").appendTo(this.contentEl);
        for(const [key, value] of Object.entries(app.bundleInfo))
            $("<div style='font-size:smaller;word-wrap:anywhere;overflow:hidden;width: 100%;margin: 4px 0;'>").text(`${key}: ${value}`).appendTo($buildInfoGroup);

        const $localSettingsGroup = $("<fieldset><legend>Client Settings</legend></fieldset>").appendTo(this.contentEl);

        for(const id of this.localSettings)
            $(`<p><label for='input_localSettings_${id}'>${id}</label><br><input id="input_localSettings_${id}" data-localstorage="${id}" type="text" onfocus="this.value=localStorage[this.getAttribute('data-localstorage')]" onblur="localStorage[this.getAttribute('data-localstorage')]=this.value" onkeydown="event.stopPropagation()"></p>`).appendTo($localSettingsGroup).find("input").val(window.localStorage[id] || '');

        const $userSettingsGroup = $("<fieldset><legend>User Settings</legend></fieldset>").appendTo(this.contentEl);

        for(const id of this.userMetaSettingsArray)
            $(`<p><label for='input_userMetaSettings_${id}'>${id}</label><br><input id="input_userMetaSettings_${id}" data-userMetaSettings="${id}" type="text" disabled onkeydown="event.stopPropagation()"></p>`).appendTo($userSettingsGroup).find("input").blur(function() { if (!app.remote.loginUser.meta) app.remote.loginUser.meta = {}; app.remote.loginUser.meta[this.getAttribute('data-userMetaSettings')] = this.value.split(/,/); app.remote.rpcMethodCall("pb", "pb", 'pb', "set_user_meta", [app.remote.loginUser.meta], {}); });
        for(const id of this.userMetaSettingsString)
            $(`<p><label for='input_userMetaSettings_${id}'>${id}</label><br><input id="input_userMetaSettings_${id}" data-userMetaSettings="${id}" type="text" disabled onkeydown="event.stopPropagation()"></p>`).appendTo($userSettingsGroup).find("input").blur(function() { if (!app.remote.loginUser.meta) app.remote.loginUser.meta = {}; app.remote.loginUser.meta[this.getAttribute('data-userMetaSettings')] = this.value; app.remote.rpcMethodCall("pb", "pb", 'pb', "set_user_meta", [app.remote.loginUser.meta], {}); });

        const pubkeyGroup = $("<fieldset><legend>Public Key</legend></fieldset>").appendTo(this.contentEl);
        pubkeyGroup.append(EL('p', {}, app.crypto.clientKeyPublicKeyString));
        const qr = EL('div', {style:'background:white;padding:10px;'});
        pubkeyGroup.append(qr);
        new QRCode(qr, 'meow:rpc-pubkey:'+app.crypto.clientKeyPublicKeyString);
    }
    async login(){
        using _ = ProgressBar.show('logging in');
        try {
            var json = await app.remote.login($("#um_username").val() as string, $("#um_password").val() as string);
            app.remote.loginUser = json.user;
            await app.initUser($("#um_username").val() as string);
            this.showUserSettings();
            app.wndFileList.loadFilelist();
            this.collapse();
        } catch (err) {
            alert(err)
            this.show();
        }
    }
    async showUserSettings() {
        const userInfo = await app.remote.pb.get_user();
        $("[data-userMetaSettings]").each(function() { this.setAttribute('value', userInfo.meta[this.getAttribute('data-userMetaSettings')] || ''); }).prop('disabled', false);
    }
}

@registerClass(DomWindow.windowTypes)
export class ChatWindow extends LogWindow {
    textBox : HTMLInputElement;
    history : string[] = [""];
    historyIdx : number = 0;
    constructor(id:string, defaultBounds:DomWindowBounds) {
        super(id, defaultBounds);
        this.hideOnClose = true;
        this.$footer.append(this.textBox = EL("input", {type:"text", style:'height:30px;width:100%;border:1px solid black;'}));
        this.textBox.addEventListener('keydown', (e) => {
            if (e.key == 'Enter' && !e.ctrlKey && !e.altKey && !e.shiftKey) {
                const text = this.textBox.value;
                this.history[this.historyIdx] = text;
                if (this.historyIdx == this.history.length - 1) this.history.push("");
                this.historyIdx = this.history.length - 1;
                if (text.startsWith("{")) {
                    this.context.sel.toolbarClick(JSON.parse(text), null);
                } else {
                    app.remote.onSendChatMessage(text);
                }
                this.textBox.value = "";
                return false;
            } else if (e.key=='ArrowUp') {
                this.history[this.historyIdx] = this.textBox.value;
                if (this.historyIdx>0) this.historyIdx--;
                this.textBox.value = this.history[this.historyIdx];
                return false;
            } else if (e.key=='ArrowDown') {
                this.history[this.historyIdx] = this.textBox.value;
                if (this.historyIdx < this.history.length-1) this.historyIdx++;
                this.textBox.value = this.history[this.historyIdx];
                return false;
            }
        })
    }
}

@registerClass(DomWindow.windowTypes)
export class ItemSearchWindow extends DomWindow {
    @observable
    public accessor grid : GridCtrl;
    $textBox:JQuery;
    urlSettingsKey='';
    cancellation : AbortController | null = null;
    constructor(id: string, defaultBounds: DomWindowBounds) {
        super(id, defaultBounds);
        this.$textBox = $("<input type=text style='height:30px;width:100%;border:1px solid black;' placeholder='search...   [enter: search; alt+a: select all, +ctrl: add to sel; alt+c: copy saved search]'>").appendTo(this.$footer)
        this.$textBox[0].addEventListener('keydown', async (e) => {
            const key = keyname(e);
            if (key == 'Enter') {
                this.search(undefined);
                super.navigate(new URL(this.buildURL()));
            }
            if (key == 'ctrl- ') {
                this.grid.showColMenu(null);
            }
            if (key == 'alt-c') {
                var item = [{
                    text: 'search: `'+this.$textBox.val()+'`',
                    param: this.buildURL(),
                    x: 20, y: 20, width: 200, height:24, icon: '🔎', clickAppMethod: 'navigate'
                }];
                navigator.clipboard.writeText(JSON.stringify(item));
                app.selectionManager.lastCopiedToClipboard = structuredClone(item);
            }
            if (key == 'alt-a') {
                this.selectResults(e.ctrlKey);
            }
        });
        
        this.grid = new GridCtrl(this.$content[0], {
            initialCols: ["document","id","text"],
            settingsKey: 'gridwnd',
            selectOnClick: ClickSelectMode.Single,
            allowMultiSelect: true,
            rootObjectType: 'MEMOITEM',
        });
        this[Symbol.dispose].defer(() => {
            if (this.cancellation) this.cancellation.abort();
        });
    }
    buildURL(): string {
        return "itemsearchwindow:?q=" + encodeURIComponent(''+this.$textBox.val()) + "&cols=" + encodeURIComponent(JSON.stringify(this.grid.cols))
            + (this.urlSettingsKey ? "&id=" + encodeURIComponent(this.urlSettingsKey) : '')
    }
    async onNavigate(url: URL, opts: OnNavigateOptions) {
        await super.onNavigate(url, opts);
        const params = new URLSearchParams(url.search);
        this.$content.html('');
        if (params.has('cols') && params.has('id')) this.urlSettingsKey = params.get('id');
        this.grid = new GridCtrl(this.$content[0], {
            initialCols: params.has('cols') ? JSON.parse(params.get('cols')) : ["document","id","text"],
            settingsKey: params.has('cols') ? (params.has('id') ? params.get('id') : undefined) : 'gridwnd',
            selectOnClick: ClickSelectMode.Single,
            allowMultiSelect: true,
            rootObjectType: 'MEMOITEM',
        });
        if (params.has('q')) this.search(params.get('q'));
        if (opts.focus) this.$textBox.focus();
    }
    selectResults(keepExistingSelection?: boolean) {
        if (!keepExistingSelection) app.selectionManager.deselectAll();
        const curDoc = app.selectionManager.activeMemo.documentId;
        const items = this.grid.data.filter(x => x.document === curDoc).map(x => app.selectionManager.activeMemo.items[x.id]);
        app.selectionManager.selectMultiple(items);
    }
    async search(term?: string, selectResults?: boolean, keepExistingSelection?: boolean): Promise<void> {
        if (term) this.$textBox.val(term);
        if (this.cancellation) this.cancellation.abort();
        const matcher = new MemoItemSearchMatcher(this.$textBox.val() as string);
        this.cancellation = new AbortController();
        const result = await matcher.performSearch(undefined, undefined, this.cancellation.signal);
        this.grid.setData(result, true);
        if (matcher.secondaryKeys.length) 
            this.grid.addCols(matcher.secondaryKeys.flatMap(kr => 
            typeof kr === 'string' 
                          ? kr
                          : result.flatMap(item => Object.keys(item).filter(k => kr.test(k)))).map(key => ({ key })));
            
            
    }

    @slot('grid', ($: GridCtrl) => $.buildContextMenu)
    buildContextMenu(targetItems : any[], o: any, cell: HTMLDivElement, e: MouseEvent): any[] {
        if (targetItems.length === 1) {
            const memo = app.findMemoWithDocument(targetItems[0].props.document);
            if (memo) {
                const item = memo.items[targetItems[0].props.id];
                if (item) {
                    return [{ text: '--> Item Context Menu', action: () => item.contextMenu(null) }];
                }
            }
        }
        return [];
    }

    @slot('grid', ($: GridCtrl) => $.itemClicked)
    async onItemClicked(data: any, e: MouseEvent) {
        const holder = await app.navigate(data.document, undefined, e.altKey);
        const memo = holder.activity as MemoActivity;
        if (memo.items[data.id]) {
            if (!e.ctrlKey) memo.sel.deselectAll();
            memo.sel.select(memo.items[data.id]);
            memo.items[data.id].el.scrollIntoView();
            memo.focus();
        }
    }

    @slot(() => app, 'db', ($: LocalDb) => $.remoteItemUpdated)
    onRemoteItemUpdate(item: any, docId: string) {
        for(let i = 0; i < this.grid.data.length; i++) {
            const row = this.grid.data[i];
            if (row.document === docId && row.id === item.id) {
                Object.assign(row, item);
                this.grid.fillRowWithData(row[GridCtrl._tr], row, true);
            }
        }
    }

}


@registerClass(DomWindow.windowTypes)
export class UndoWindow extends DomWindow {
    @observable
    public accessor tree : TreeCtrl;
    constructor() {
        super();
        this.tree = new TreeCtrl(this.$content[0], {
            initialCols: ["mt","id","text"],
            settingsKey: 'undowindow',
            selectOnClick: ClickSelectMode.Single,
            allowMultiSelect: true,
        });
    }

    @slot(() => app.selectionManager, 'activeMemo$')
    activeMemoChanged() {
        this.tree.setTreeData([{}, app.selectionManager.activeMemo.undoStack.map(x => [x, []])])
    }

}

@registerClass(DomWindow.windowTypes)
export class FileListWindow extends DomWindow {
    @observable
    public accessor tree : TreeCtrl;
    constructor(id:string, defaultBounds:DomWindowBounds) {
        super(id, defaultBounds);
        this.hideOnClose = true;
        this.addTitleButton("🔄", () => this.loadFilelist());
        this.$content.css('overflow', 'hidden');
        this.$content.css('user-select', 'none');
        this.tree = new TreeCtrl(this.$content[0], {
            initialCols: ["filename"],
            settingsKey: this.id,
            rootObjectType: 'DOCUMENT',
        });
    }

    @slot('tree', ($: GridCtrl) => $.itemClicked)
    onItemClicked(o: any, e: MouseEvent) {
        if (o.__docId) app.navigate(o.__docId, undefined, e.altKey);
    }
/*
// TODO
    not sure how to do this property...
    URL of DomWindow.current?
    but what if e.g. FileListWindow itself gets focused??
    */
    @slot(() => app, 'mainViewer', ($: ActivityHolder) => $.navigated)
    onMainMemoNavigated(url: URL) {
        if (url?.protocol === 'memo:') {
            this.tree.deselectAll();
            this.tree.addToSelection(this.tree.data.filter(x => x.__docId == url.pathname));
        }
    }

    async loadFilelist() {
        this.tree.clearRows();
        for(const mountOptions of await app.getFilelistRoots()) {
            const dir = mountOptions.user;
            const files = (await app.remote.rpcMethodCall('pb', 'pb', 'pb', "list_dir", [dir], {})).files;
            const fileInfos = await Promise.all(files.map(async file => Object.assign({path: file}, await app.db.getItem(file, 'meta'), { __docId: file })));
            fileInfos.sort((x,y) => x.path.localeCompare(y.path));
            var treedata : [any, any] = [{'filename':dir,'path':dir}, []];
            for(const file of fileInfos) {
                const path = file.path.split(/\//);
                var arr : any[] = [treedata];
                path.forEach((pathel, index) => {
                    for (var i = 0; i < arr.length; i++) {
                        if (arr[i][0].filename == pathel) {
                            arr = arr[i][1];
                            return;
                        }
                    }
                    const thisPath = path.slice(0,index+1).join('/');
                    var n = [Object.assign({}, index+1==path.length ? file : null, {'filename': pathel, 'path': thisPath, '_stateId': thisPath }), []];
                    arr.push(n);
                    arr = n[1] as any[];
                });
            }
            await this.tree.addRoot(treedata, 1);
        }
    }
}
function animateFling(el, startTime, curPos) : Promise<void> {
    return new Promise((resolve, reject) => {
        if (!curPos) return;
        const endPos = el.clientWidth;
        let speed = curPos / (window.performance.now() - startTime);
        console.log("animateFling",speed)
        if (speed >= 0 && speed < 0.25) speed = 0.25;
        if (speed < 0 && speed > -0.25) speed = -0.25;

        const animation = (time) => {
            const nowPos = speed * (time - startTime);
            el.style.transform = "translate(" + nowPos + "px, 0)";
            if (nowPos < endPos && nowPos > -endPos) requestAnimationFrame(animation);
            else { resolve(); }
        };
        requestAnimationFrame(animation);
    });
}
@registerClass(DomWindow.windowTypes)
export class CalendarWindow extends DomWindow {
    @observable
    public accessor currentDate : Date = new Date();
    renderer = new SimpleCalendarRenderer();
    $calendar;
    mobileFullscreen(): boolean { return false; }

    constructor(id:string, defaultBounds:DomWindowBounds) {
        super(id, defaultBounds);
        this.hideOnClose = true;
        this.$calendar = $("<table class='calendar'>").appendTo(this.$content);
        this.addTitleButton(" << ",this.nextMonth.bind(this));
        this.addTitleButton(" >> ",this.prevMonth.bind(this));
        let startTime;
        dragdrop1d(this.$calendar[0], 'x', [{
            button: 1, condition: (o, s) => true, init: (v) => { startTime = window.performance.now(); return 0 },
            transform: (newval, d) => this.$calendar[0].style.transform = 'translate(' + newval + 'px, 0)',
            abortMove: () => this.$calendar[0].style.transform = '',
            finishMove: (newval, d) => {
                if (newval < -20) {
                    this.prevMonth(); animateFling(this.$calendar[0], startTime, newval).then(() => this.$calendar[0].style.transform = '');
                } else if (newval > 20) {
                    this.nextMonth(); animateFling(this.$calendar[0], startTime, newval).then(() => this.$calendar[0].style.transform = '');
                }
            }, allowDefault: false
        }])
        this.updateCalendar();
    }

    nextMonth() {
        if (this.currentDate.getMonth() === 0) {
            this.currentDate = new Date(this.currentDate.getFullYear() - 1, 11);
        } else {
            this.currentDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() - 1)
        }
        this.updateCalendar();
    }
    prevMonth() {
        if (this.currentDate.getMonth() === 11) {
            this.currentDate = new Date(this.currentDate.getFullYear() + 1, 0);
        } else {
            this.currentDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1)
        }
        this.updateCalendar();
    }

    @slot(() => app, 'mainViewer', ($: ActivityHolder) => $.navigated)
    onMainMemoNavigated(url: URL) {
        if (url.protocol !== 'memo:') return;
        const docDate = Date.parseDocDate(url.pathname);
        if (docDate?.start) {
            this.currentDate = new Date(docDate.start.getFullYear(), docDate.start.getMonth(), docDate.start.getDate());
        }
        this.updateCalendar();
    }
    
    async updateCalendar() {
        const d = this.currentDate;
        const prefix = $("#um_username").val() + "/journal/";
        const monthPrefix = prefix + d.toLocaleDateString('sv-SV').substr(0,8);
        const docIds = new Set(await app.db.getDocumentIds(monthPrefix));
        const self = this;
        const cal = this.renderer.getCalendarHtml(d, (thisDate: Date) => {
            var docId = prefix + thisDate.toLocaleDateString('sv-SV');
            var cls = 'day';
            if (thisDate.isToday()) cls += ' today';
            if (docId == app.myMemo?.documentId) cls += ' active';
            if (docIds.has(docId)) cls += ' hasdoc';
            if (thisDate.getDay() == 0 || thisDate.getDay() == 6) cls += ' weekend';
            const linkAttrs = DomWindowConfig.isMobileMode ? { onclick: function(e) {
                e.stopPropagation(); e.preventDefault();
                if (+self.currentDate === +thisDate) {
                    app.navigate(docId, undefined, false, true);
                    self.hide();
                } else {
                    self.currentDate = thisDate;
                }
                return false;
            }, href: '?' + docId } : {href: '?' + docId};
            return { tdAttrs: {'class': cls}, linkAttrs };
        });
        this.$calendar.html('').append(cal);
        this.setTitle(this.renderer.months[d.getMonth()] + " " + d.getFullYear());
        
    }

}

class SimpleCalendarRenderer {
    weekDays = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];
    months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    
    constructor() {
    }
    monthDays(that : Date) {
        var d = new Date(that.getFullYear(), that.getMonth() + 1, 0);
        return d.getDate();
    }
    getCalendarHtml(d: Date, dayInfo: (d: Date) => {tdAttrs: any, linkAttrs: any}): HTMLElement[] {
        const totalDays = this.monthDays(d);
        const start = (new Date(d.getFullYear(), d.getMonth()).getDay() + 6) % 7;
        var cal = [];
        var day = 1 - start;
        for (var i = 0; i <= 6; i++) {
            const cells = [];
            for (var j = 0; j < 7; j++) {
                if (i === 0) {
                    cells.push(EL('td', {}, this.weekDays[j]));
                } else {
                    const thisDate = new Date(d.getFullYear(), d.getMonth(), day, 0, 0, 0);
                    const {tdAttrs, linkAttrs} = dayInfo(thisDate);
                    let label = `${thisDate.getDate()}`;
                    if (thisDate.getMonth() !== d.getMonth()) {
                        tdAttrs['class'] += ' othermonth';
                        label = `(${label})`;
                    }
                    cells.push(EL('td', tdAttrs, EL('a', linkAttrs, label)));
                    day++;
                }
            }
            cal.push(EL('tr', {}, ...cells));
        }
        return cal;
    }
}
